/* @ngInject */
function ManageCustomFieldsController ($scope, $timeout, NewAssetService) {
  $scope.changedFields = []

  const api = {
    _getCustomFields,
    _categorizeFieldsByType
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._getCustomFields()
  }

  function _getCustomFields () {
    const assetId = $scope.assets[0].id

    NewAssetService.getCustomFields().then((customFields) => {
      NewAssetService.getAssetCustomFieldsValue(assetId).then((fieldValues) => {
        $scope.customFields = api._categorizeFieldsByType(customFields.rows, fieldValues)
      })
    })
  }

  function _categorizeFieldsByType (customFields, fieldValues) {
    const fieldsByType = {
      DROPDOWN: [],
      TEXT: [],
      DATE: [],
      CHECKBOX: []
    }

    customFields.forEach(customField => {
      const fieldValue = fieldValues.find(value => value.customFieldId === customField.id)

      if (fieldsByType[customField.type]) {
        if (customField.type === 'DROPDOWN' && customField.options) {
          customField.options = customField.options.map(option => ({
            label: option.title,
            value: option.id,
            active: option.id === parseInt(fieldValue?.value, 10)
          }))
        } else {
          customField.fieldValue = fieldValue ? fieldValue.value : null
        }

        fieldsByType[customField.type].push(customField)
      }
    })

    return fieldsByType
  }

  $scope.onChangeCustomFields = (event, customFieldId, isSelect) => {
    let newValue = event?.detail?.value || event?.detail?.date
    let fieldId = customFieldId
    $scope.flags.hasSave = false

    if (isSelect) {
      newValue = event?.detail?.value
      fieldId = customFieldId
    }

    if (fieldId) {
      const existingFieldIndex = $scope.changedFields.findIndex(field => field.id === fieldId)

      if (existingFieldIndex !== -1) {
        $scope.changedFields[existingFieldIndex].value = newValue
      } else {
        $scope.changedFields.push({ id: fieldId, value: newValue })
      }
    }

    $scope.form.customFields = $scope.changedFields
  }
}

export { ManageCustomFieldsController }
